import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React from "react";
function BaseIcon(_ref) {
    const color = _ref.color;
    const _ref$pushRight = _ref.pushRight;
    const pushRight = _ref$pushRight === undefined ? true : _ref$pushRight;
    const children = _ref.children;
    return React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        style: { marginRight: pushRight ? "20px" : "0", minWidth: 24, marginTop: -4 },
    }, children);
}
function InfoIcon() {
    return React.createElement(BaseIcon, { color: "#5198f4" }, React.createElement("circle", { cx: "12", cy: "12", r: "10" }), React.createElement("line", { x1: "12", y1: "16", x2: "12", y2: "12" }), React.createElement("line", { x1: "12", y1: "8", x2: "12", y2: "8" }));
}
function SuccessIcon() {
    return React.createElement(BaseIcon, { color: "#2bd18f" }, React.createElement("path", { d: "M22 11.08V12a10 10 0 1 1-5.93-9.14" }), React.createElement("polyline", { points: "22 4 12 14.01 9 11.01" }));
}
function ErrorIcon() {
    return React.createElement(BaseIcon, { color: "#ef615e" }, React.createElement("circle", { cx: "12", cy: "12", r: "10" }), React.createElement("line", { x1: "12", y1: "8", x2: "12", y2: "12" }), React.createElement("line", { x1: "12", y1: "16", x2: "12", y2: "16" }));
}
function CloseIcon() {
    return React.createElement(BaseIcon, { color: "#dfe7f5", pushRight: false }, React.createElement("line", { x1: "18", y1: "6", x2: "6", y2: "18" }), React.createElement("line", { x1: "6", y1: "6", x2: "18", y2: "18" }));
}
export const KAlertTemplate = ({ style, options, message, close }) => (_jsx("div", { style: { ...style, width: "auto", backgroundColor: "#363D49", padding: 10, fontFamily: "KDefaultFont, sans-serif", color: "#dfe7f5", fontSize: 18 }, children: _jsxs("div", { style: { display: "block" }, children: [_jsxs("span", { children: [options.type === "info" && InfoIcon(), options.type === "success" && SuccessIcon(), options.type === "error" && ErrorIcon()] }), _jsx("span", { style: { marginTop: 5 }, children: message }), _jsx("button", { onClick: close, className: "btn btn-link", style: { padding: 0, paddingLeft: 10, border: "none", marginTop: -3 }, children: CloseIcon() })] }) }));
